import React from "react";
import Grid from "@material-ui/core/Grid";
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import LayersIcon from '@material-ui/icons/Layers';
import SettingsIcon from '@material-ui/icons/Settings';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';

import useStyles from "./styles";

import CustomerImg from "../../images/customer.webp";
import { Container } from "@material-ui/core";

export default function Customer() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6} className={classes.leftPart}>
              <p className={classes.capital}>Customer success</p>
              <p className={classes.title}>Accelerate time to value</p>
              <p className={classes.content}>Get the most out of Venus products by partnering with our Customer Success team.</p>
              <p className={classes.content}>At Venus, we are passionate about our customer's journey to value and success. We provide a best-in-class customer experience, delivered through proactive education, enablement, and proven best-practices.</p>
            </Grid>
            <Grid item xs={6} className={classes.rightPart}>
              <img src={CustomerImg} width={"100%"} alt="customer-img" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Grid container className={classes.bottomPart}>
            <Grid item xs={5}>
              <Grid container className={classes.bottomContent}>
                <Grid xs={1} />
                <Grid xs={10}>
                  <p>Venus offers a range of customer success and support options to fit the needs and budget of every business. Our capabilities include:</p>
                </Grid>
                <Grid xs={1} />
              </Grid>
            </Grid>
            <Grid item xs={7}>
              <Grid container className={classes.bottomContent}>
                <Grid item xs={3}>
                  <ViewCarouselIcon color={"secondary"} />
                  <p>Onboarding</p>
                </Grid>
                <Grid item xs={3}>
                  <SettingsIcon color={"secondary"} />
                  <p>Adoption</p>
                </Grid>
                <Grid item xs={3}>
                  <LayersIcon color={"secondary"} />
                  <p>Integration</p>
                </Grid>
                <Grid item xs={3}>
                  <TrendingUpIcon color={"secondary"} />
                  <p>Scale</p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}